var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8204 4.42578H2.42639V5.07225H21.8204V4.42578Z",
    fill: "#8F95B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3557 17.3555H2.42639V18.0019H15.3557V17.3555Z",
    fill: "#8F95B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8204 10.8906H2.42639V11.5371H21.8204V10.8906Z",
    fill: "#8F95B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46067 4.42578H2.81421V18.648H3.46067V4.42578Z",
    fill: "#8F95B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.097 4.42578H14.4506V18.648H15.097V4.42578Z",
    fill: "#8F95B2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27891 4.42578H8.63245V18.648H9.27891V4.42578Z",
    fill: "#8F95B2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9153 4.42578H20.2688V12.1834H20.9153V4.42578Z",
    fill: "#8F95B2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07273 7.14547C4.21747 7.14547 5.14547 6.21747 5.14547 5.07273C5.14547 3.92799 4.21747 3 3.07273 3C1.92799 3 1 3.92799 1 5.07273C1 6.21747 1.92799 7.14547 3.07273 7.14547Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07273 13.6103C4.21747 13.6103 5.14547 12.6823 5.14547 11.5376C5.14547 10.3928 4.21747 9.46484 3.07273 9.46484C1.92799 9.46484 1 10.3928 1 11.5376C1 12.6823 1.92799 13.6103 3.07273 13.6103Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07273 20.0752C4.21747 20.0752 5.14547 19.1472 5.14547 18.0024C5.14547 16.8577 4.21747 15.9297 3.07273 15.9297C1.92799 15.9297 1 16.8577 1 18.0024C1 19.1472 1.92799 20.0752 3.07273 20.0752Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89097 7.14547C10.0357 7.14547 10.9637 6.21747 10.9637 5.07273C10.9637 3.92799 10.0357 3 8.89097 3C7.74623 3 6.81824 3.92799 6.81824 5.07273C6.81824 6.21747 7.74623 7.14547 8.89097 7.14547Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89097 13.6103C10.0357 13.6103 10.9637 12.6823 10.9637 11.5376C10.9637 10.3928 10.0357 9.46484 8.89097 9.46484C7.74623 9.46484 6.81824 10.3928 6.81824 11.5376C6.81824 12.6823 7.74623 13.6103 8.89097 13.6103Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89097 20.0752C10.0357 20.0752 10.9637 19.1472 10.9637 18.0024C10.9637 16.8577 10.0357 15.9297 8.89097 15.9297C7.74623 15.9297 6.81824 16.8577 6.81824 18.0024C6.81824 19.1472 7.74623 20.0752 8.89097 20.0752Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5273 7.14547C21.6721 7.14547 22.6001 6.21747 22.6001 5.07273C22.6001 3.92799 21.6721 3 20.5273 3C19.3826 3 18.4546 3.92799 18.4546 5.07273C18.4546 6.21747 19.3826 7.14547 20.5273 7.14547Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7091 13.6103C15.8538 13.6103 16.7818 12.6823 16.7818 11.5376C16.7818 10.3928 15.8538 9.46484 14.7091 9.46484C13.5643 9.46484 12.6364 10.3928 12.6364 11.5376C12.6364 12.6823 13.5643 13.6103 14.7091 13.6103Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7091 20.0752C15.8538 20.0752 16.7818 19.1472 16.7818 18.0024C16.7818 16.8577 15.8538 15.9297 14.7091 15.9297C13.5643 15.9297 12.6364 16.8577 12.6364 18.0024C12.6364 19.1472 13.5643 20.0752 14.7091 20.0752Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7091 7.14547C15.8538 7.14547 16.7818 6.21747 16.7818 5.07273C16.7818 3.92799 15.8538 3 14.7091 3C13.5643 3 12.6364 3.92799 12.6364 5.07273C12.6364 6.21747 13.5643 7.14547 14.7091 7.14547Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5273 13.6103C21.6721 13.6103 22.6001 12.6823 22.6001 11.5376C22.6001 10.3928 21.6721 9.46484 20.5273 9.46484C19.3826 9.46484 18.4546 10.3928 18.4546 11.5376C18.4546 12.6823 19.3826 13.6103 20.5273 13.6103Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.a1cac6505a7011ff0298039668bd93af.svg";
export { ForwardRef as ReactComponent };